var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5605 10.4781L10.167 2.87159L9.1065 1.81109L1.5 9.41759V10.4781H2.5605ZM3.18225 11.9781H0V8.79584L8.57625 0.21959C8.7169 0.0789867 8.90763 0 9.1065 0C9.30537 0 9.4961 0.0789867 9.63675 0.21959L11.7585 2.34134C11.8991 2.48199 11.9781 2.67272 11.9781 2.87159C11.9781 3.07046 11.8991 3.26119 11.7585 3.40184L3.18225 11.9781ZM0 13.4781H13.5V14.9781H0V13.4781Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e854fe5c0fef3ac8e30ce3fdff36a61c.svg";
export { ForwardRef as ReactComponent };